import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomerReviewModel, UploadFileModel } from 'src/app/models/review';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ReviewManagementService } from 'src/app/services/review-management.service';
import { ProductNameComponent } from '../product-name/product-name.component';
import { ReviewMessageComponent } from '../review-message/review-message.component';

@Component({
  selector: 'app-customer-review-form',
  templateUrl: './customer-review-form.component.html',
  styleUrls: ['./customer-review-form.component.css']
})
export class CustomerReviewFormComponent implements OnInit {

  customerReviewModel: CustomerReviewModel = new CustomerReviewModel();
  Loader: boolean = false;
  file: any;
  imageUrl: any;
  id: number;
  showImageSubmit: boolean = false;
  uploadFileArray: UploadFileModel = new UploadFileModel();
  localStorageService: LocalstorageService;
  popUp: boolean = false;
  item: any;
  customerReviewModelMessage: string;
  customerReviewModelMessageError: string;

  constructor(private alertify: AlertifyService, private modalService: NgbModal, private _localStorageService: LocalstorageService, private _customerReviewService: ReviewManagementService, private router: Router) {
    this.customerReviewModelMessageError = "Please Login";
   }

  ngOnInit() {
  }

  onSubmit() {
      if (this.customerReviewModel.name == undefined || this.customerReviewModel.name == null || this.customerReviewModel.name == "") {
        this.alertify.error("Name is required");
        return;
      }
      if (this.customerReviewModel.title == undefined || this.customerReviewModel.title == null || this.customerReviewModel.title == "") {
        this.alertify.error("Title is required");
        return;
      }
      if (this.customerReviewModel.comments == undefined || this.customerReviewModel.comments == null || this.customerReviewModel.comments == "") {
        this.alertify.error("Comment is required");
        return;
      }
      this.Loader = true;
      this._customerReviewService.customerReviewAdd(this.customerReviewModel)
        .subscribe(response => {
          var responseBody = JSON.parse(response._body);
          this.customerReviewModel = responseBody.responseData;
          this.customerReviewModelMessage = responseBody.responseMessage;
          if (responseBody.isSuccess) {
            if (this.uploadFileArray.Image != undefined) {
              this.uploadFile();
            }
            else {
              this.reviewLogin(this.customerReviewModelMessage)
              this.Loader = false;
              document.forms[0].reset();
              this.customerReviewModel = new CustomerReviewModel();
            }
          } else {
            this.Loader = false;
          }
        });
  }

  uploadFile() {
    if (this.uploadFileArray.Image.name.toLowerCase().includes('.png') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpg') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpeg')) {
      this.uploadFileArray.Id = this.customerReviewModel.id;
      this.showImageSubmit = false;
      this._customerReviewService.uploadCustomerImage(this.uploadFileArray)
        .subscribe((rec) => {
          this.Loader = false;
          this.reviewLogin(this.customerReviewModelMessage)
          this.imageUrl = '';
          document.forms[0].reset();
          this.customerReviewModel = new CustomerReviewModel();
        });
    } else {
      this.alertify.error("Only files in .jpg, .jpeg, .png format are accepted and directories are not allowed.");
    }
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.file);
    this.uploadFileArray.Image = this.file;
    this.showImageSubmit = true;
  }

  reviewLogin(customerReviewModelMessage) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm review-modal";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ReviewMessageComponent, modalConfig);
    modalRef.componentInstance.customerReviewModelMessage = customerReviewModelMessage;
  }

  reviewLoginError(customerReviewModelMessageError) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm review-modal";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ReviewMessageComponent, modalConfig);
    modalRef.componentInstance.customerReviewModelMessageError = customerReviewModelMessageError;
  }
}
